/**
 * 远程文件发送(v1)。公共入口 `sendFile`,实际发送状态机在 `./session`
 * (与通道消息处理同模块,避免环依赖)。保留 `sendFile(file, handlers)` 签名供 UI 调用。
 */
import { type FileSendCallbacks, startFileSend } from "./session";

/**
 * 发送文件到远端(§8)。async 内部 fire-and-forget——进度/状态/完成/错误全部通过
 * `handlers` 回调驱动 UI;调用方无需 await。
 */
export const sendFile = (
	file: File | null,
	handlers: FileSendCallbacks = {},
): void => {
	void startFileSend(file, handlers);
};
